export default "__VITE_ASSET__CQPik$i7__"